import PortalIdParser from 'PortalIdParser';
import Routes from 'automation-ui-canvas/constants/Routes';
import EnrollmentHistoryPageSidePanel from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/EnrollmentHistoryPageSidePanel';
import { getIsClassicWorkflow } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { getEnrollmentHistoryUrl } from 'automation-ui-canvas/utils/urls';
import BasePaths from 'automation-ui-routing/BasePaths';
import ListBranchDebugPanel from 'flow-doctor-lib/components/actions/ListBranchDebugPanel';
import EnrollmentDiagnosisPanel from 'flow-doctor-lib/components/diagnosis/EnrollmentDiagnosisPanel';
import { NavMarker } from 'react-rhumb';
import { Route, useHistory, useLocation } from 'react-router-dom';
import { getCanvasTopOffset } from 'automation-ui-canvas/utils/styleUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentHistoryPagePanelRoutes = ({
  flow,
  scrollElementRef
}) => {
  const history = useHistory();
  const {
    search
  } = useLocation();
  const canvasTopOffset = getCanvasTopOffset(scrollElementRef);
  const handleClose = () => {
    history.replace({
      pathname: getEnrollmentHistoryUrl({
        flowId: flow.flowId
      }),
      search
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Route, {
      exact: true,
      path: [`${Routes.PLATFORM_FLOW_ENROLLMENT_HISTORY_PAGE}/${BasePaths.BRANCH_DIAGNOSE}/by-id/:idempotencyId`],
      render: ({
        match: {
          params
        }
      }) => /*#__PURE__*/_jsx(ListBranchDebugPanel, {
        portalId: PortalIdParser.get(),
        flowId: flow.flowId,
        idempotencyId: params.idempotencyId,
        onClose: handleClose
      })
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: [`${Routes.PLATFORM_FLOW_ENROLLMENT_HISTORY_PAGE}/${BasePaths.ENROLLMENT_DIAGNOSE}`],
      render: () => {
        const searchParams = new URLSearchParams(search);
        return /*#__PURE__*/_jsx(EnrollmentDiagnosisPanel, {
          flowId: flow.flowId,
          enrollmentId: Number(searchParams.get('enrollmentId')),
          onClose: handleClose,
          successMarker: /*#__PURE__*/_jsx(NavMarker, {
            name: "ENROLLMENT_DIAGNOSIS_LOADED"
          }),
          failureMarker: /*#__PURE__*/_jsx(NavMarker, {
            name: "ENROLLMENT_DIAGNOSIS_FAILED"
          })
        });
      }
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: Routes.PLATFORM_FLOW_ENROLLMENT_HISTORY_PAGE,
      render: ({
        match: {
          params
        }
      }) => /*#__PURE__*/_jsx(EnrollmentHistoryPageSidePanel, {
        canvasTopOffset: canvasTopOffset,
        flow: flow.toHybridFlowInterface(),
        isHybrid: !!getIsClassicWorkflow(flow),
        subScreen: params.subScreen
      })
    })]
  });
};
export default EnrollmentHistoryPagePanelRoutes;